<script lang="ts">
  import { createEventDispatcher } from "svelte";
  import cx from "classnames";

  export let enabled: boolean;
  export let a11yLabel: string;

  const dispatch = createEventDispatcher();
  const handleClick = () => {
    dispatch("toggle", enabled);
  };

  const handleKeyDown = (event: KeyboardEvent) => {
    if (event.code === "Enter" || event.code === "Space") {
      dispatch("toggle", enabled);
    }
  };
</script>

<div
  on:click|stopPropagation={handleClick}
  on:keydown|stopPropagation={handleKeyDown}
  class={cx(
    enabled ? "bg-emerald-400" : "bg-neutral-400 dark:bg-neutral-200/20",
    "relative inline-flex h-[18px] w-8 shrink-0 cursor-pointer items-center rounded-full border-2",
    "border-transparent transition-colors duration-100 ease-in-out focus:outline-community-primary",
    "focus:outline-none focus:outline-1 focus:outline-offset-1 focus-visible:after:visible"
  )}
  role="switch"
  aria-checked={enabled}
  aria-label={a11yLabel}
  tabindex="0"
>
  <span
    aria-hidden="true"
    class={cx(
      enabled ? "translate-x-[15px]" : "translate-x-[1px]",
      "in-out-shadow pointer-events-none inline-block size-3 transform rounded-full bg-gray-100 ring-0 transition duration-100 ease-in-out after:rounded-full focus:outline-none"
    )}
  />
</div>
